import { Text } from '@eleveo/components-react';
import { ArrowIcon } from '@eleveo/icons-react';
import clsx from 'clsx';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { useAuth } from '../../app/AuthorizationProvider';
import { NullableNumber } from '../../types';

export type IntradayChartInfoValueProps = {
  showChangeOfTrend?: boolean;
  value: NullableNumber;
};

export const IntradayChartInfoValue: React.FC<IntradayChartInfoValueProps> = ({ showChangeOfTrend, value }) => {
  const { locale } = useAuth();
  const { t } = useTranslation();

  if (value === null) {
    return (
      <Text color="grey-400" size="3xl" weight="bold" className="capitalize">
        {t('layout.notAvailable')}
      </Text>
    );
  }

  return (
    <>
      {showChangeOfTrend && value !== 0 && (
        <ArrowIcon className={clsx('transform intraday__trend-arrow', value > 0 ? '-rotate-90' : 'rotate-90')} />
      )}
      <Text size="3xl" weight="bold">
        {Math.abs(value).toLocaleString(locale, { maximumFractionDigits: 0, style: 'percent' })}
      </Text>
    </>
  );
};
